import type { CellClassRules } from '@cmg/data-grid';
import { CellClassNames, createValueFormatter, formatters } from '@cmg/data-grid';
import defaultTo from 'lodash/defaultTo';

import { formatIndicationOfInterest } from '../../../../../../common/util/ioi-formatter';
import { IoiType } from '../../../../../../graphql/__generated__';
import type {
  CalendarGridColDef,
  CalendarGridRowData,
  CalendarGridValueGetterFunc,
} from '../../CalendarGrid.model';
import { DemandCellRenderer } from './DemandCellRenderer';
import { hasMultipleIoIs, Value } from './DemandCellRenderer.model';

export type { Value };

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => {
    return Array.isArray(value)
      ? formatters.truncatedArrayValueFormatter(value)
      : defaultTo(value, '-');
  },
});

export const valueGetter: CalendarGridValueGetterFunc<Value> = ({ data }) => {
  const { indicationsOfInterest, lastAllocation } = data ?? {};

  if (lastAllocation && lastAllocation.ioiType !== IoiType.Normal) {
    return lastAllocation.ioiTypeDisplayName;
  }

  return defaultTo(indicationsOfInterest, []).map(formatIndicationOfInterest);
};

export const cellClassRules: CellClassRules<CalendarGridRowData, Value> = {
  // Show tooltip only if there are multiple indications of interest
  [CellClassNames.CELL_WITH_TOOLTIP]: ({ value }) => hasMultipleIoIs(value),
};

const demandColDef: CalendarGridColDef<Value> = {
  colId: 'demand',
  headerName: 'Demand',
  type: 'text',
  width: 152,
  sortable: false,
  filter: false,
  valueGetter,
  valueFormatter,
  useValueFormatterForExport: false,
  cellRenderer: DemandCellRenderer,
  cellClassRules,
};

export default demandColDef;
